import acceptLanguageParser from 'accept-language-parser'
import axios from 'axios'
import { isReservedShopId } from '~/lib/reservedShopId'

function localeFromAcceptLanguage (acceptLanguage: string): string | null {
  const language = acceptLanguageParser.parse(acceptLanguage)
  if (language.length === 0) {
    return null
  }
  switch (language[0]?.code) {
    case 'fi':
      return 'fi_FI'
    case 'sv':
      return 'sv_SE'
    case 'de':
      return 'de_DE'
    case 'it':
      return 'it_IT'
    case 'es':
      return 'es_ES'
    case 'fr':
      return 'fr_FR'
    case 'ru':
      return 'ru_RU'
    case 'nb':
      return 'nb_NO'
    case 'en':
    default:
      return 'en_US'
  }
}

export default defineNuxtRouteMiddleware(async (to) => {
  const pathArr = to.path.split('/')
  const path = pathArr[1]
  const store = useNuxtApp().$store as any
  const config = useRuntimeConfig().public
  let locale = store.state.locale
  store.dispatch('setBaseDomain', config.baseDomain)
  store.dispatch('setLocalDomain', config.localDomain)
  if (!locale && path && !isReservedShopId(path)) {
    // Prefer shop Settings UI language (public.json) over a possibly stale session locale.
    try {
      const response = await axios.get(config.baseDomain + path + '/settings/public.json')
      locale = response.data.locale
    } catch (e) {
      // Fall through to session / Accept-Language.
    }

    if (!locale) {
      const { session } = useUserSession()
      if (session.value?.locale) {
        locale = session.value.locale
      }
    }

    if (!locale) {
      const headers = useRequestHeaders()
      if (headers['accept-language']) {
        locale = localeFromAcceptLanguage(headers['accept-language'])
      }
    }

    if (locale) {
      await store.dispatch('setLocale', locale)
    }
  }
})
